const { permissions } = require('../../../../constants/permissions');

require('./credentialsDialog.style.scss');
const VM_PROTECTED_DELETED = 'PROTECTED_DELETED';

class CredentialsDialogController {
    constructor(
        $scope,
        $animate,
        $element,
        $filter,
        $timeout,
        $document,
        crudService,
        utilsService,
        persistence,
        dialogService,
        notificationService,
        contentSwitcherService,
        validationsService,
        iamPersistenceService
    ) {
        this.$scope = $scope;
        this.$animate = $animate;
        this.$element = $element;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$document = $document;
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.dialogService = dialogService;
        this.notificationService = notificationService;
        this.iamPersistenceService = iamPersistenceService;
        this.contentSwitcherService = contentSwitcherService;
        this.persistence = persistence;
        this.mainTitle = this.$filter('translate')('vm.credentials.title');
        this.modalTitle = this.mainTitle;
        this.modalSubTitle = null;
        this.configCredGroupTable();
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';

        this.CREATE_STATE = 'create';
        this.EDIT_STATE = 'edit';
        this.MAIN_STATE = 'main';
    }

    $onInit() {
        this.protocolList = [
            { label: 'SSH', value: 'SSH' },
            { label: 'WinRM', value: 'WIN_RM' },
        ];

        this.authenticationList = [
            { label: 'Password Authentication', value: 'PASSWORD' },
            { label: 'Public Key Authentication', value: 'PUBLIC_KEY' },
            { label: 'Private Key Authentication', value: 'PRIVATE_KEY' },
        ];

        this.authType = this.authenticationList[0];
        this.defaultProtocol = {
            label: 'Automatic',
            value: 'AUTO',
            isDefault: true,
            isOriginal: true,
            isSelected: true,
        };
        this.protocol = this.defaultProtocol;
        this.privateKeyJson = {};
        this.privateKeyNameJson = {};

        if (this.animateSwitcher && !this.minInnerHeight) {
            this.minInnerHeight = this.getMinHeight();
        }
        this.connectionTypeList = [{ label: 'HTTP', value: 'HTTP' }];
        this.defaultConnection = {
            label: 'HTTPS',
            value: 'HTTPS',
            isDefault: true,
            isOriginal: true,
            isSelected: true,
        };

        this.actionButtons = [
            {
                title: this.$filter('translate')('component.protectionGroupDialog.btn.unassign.label'),
                action: () => this.clearCredentials(false),
                isDisabled: () => !this.isUnassignAllEnbled,
                isVisible: () => this.state === this.MAIN_STATE,
                id: 'virtual-machines-credentials-unassign',
            },
            {
                title: this.$filter('translate')('vm.credentials.form.assign.btn.label'),
                action: () => this.assignCredGroup(this.selectedCredGroups[0]),
                isDisabled: () =>
                    !this.selectedCredGroups ||
                    !this.selectedCredGroups.length ||
                    !this.selectedVms ||
                    !this.selectedVms.length ||
                    _.some(this.selectedVms, { ostype: 'Linux' }),
                isVisible: () => this.state === this.MAIN_STATE,
                id: 'virtual-machines-credentials-assign',
            },
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => {
                    this.onBackAction();
                },
                isVisible: () => this.state !== this.MAIN_STATE,
                btnClass: 'ctx-btn-secondary',
                id: 'virtual-machines-credentials-back',
            },
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: () => this.saveCredGroup(),
                isDisabled: () => this.isSaveDisabled(),
                isVisible: () => this.state !== this.MAIN_STATE,
                id: 'virtual-machines-credentials-save',
            },
        ];

        this.$element.on('keydown', (e) => {
            if (!!this.$document.find('.message-box')[0]) return;
            if (
                e.keyCode == 13 &&
                this.showModal &&
                this.state === 'main' &&
                this.selectedCredGroups &&
                this.selectedVms.length !== 0 &&
                this.credGroups.length !== 0
            ) {
                e.preventDefault();
                e.stopPropagation();
                this.assignCredGroup(this.selectedCredGroups[0]);
            }
        });
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === this.MAIN_STATE) {
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.protocol = this.defaultProtocol;
        } else {
            if (this.authType.value === 'PASSWORD' && state === this.EDIT_STATE && this.credGroup.hasPassword) {
                this.credGroup.password = '********';
            } else {
                this.credGroup.password = undefined;
            }
            this.credGroup.sshKey = this.credGroup.sshKey && state === this.EDIT_STATE ? '********' : undefined;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle =
                ' » ' +
                (state === this.CREATE_STATE
                    ? this.$filter('translate')('vm.credentials.new.title')
                    : this.$filter('translate')('vm.credentials.edit.title') + ' ' + this.credGroup.name);
        }
        this.state = state;
    }

    onChangePassword() {
        if (this.enableChangePass) {
            this.credGroup.password = undefined;
            this.$timeout(() => {
                this.resetPassword = true;
            }, 0);
        } else {
            this.credGroup.password = '********';
            this.resetPassword = false;
        }
    }

    onChangeSSHKey() {
        if (this.enableChangeSSHKey) {
            this.credGroup.sshKey = undefined;
            this.$timeout(() => {
                this.resetSSHKey = true;
            }, 0);
        } else {
            this.credGroup.sshKey = '********';
            this.resetSSHKey = false;
        }
    }

    newCredentials() {
        this.credGroup = this.persistence.newCredGroup();
        this.enableChangePass = true;
        this.enableChangePrivateKey = true;
        this.privateKeyJson = {};
        this.connectionType = this.defaultConnection;
        this.privateKeyNameJson = {};
        this.changeState(this.CREATE_STATE);
    }

    editCredentials() {
        this.privateKeyJson = {};
        this.privateKeyNameJson = {};
        return this.persistence.getCredGroup(this.selectedCredGroups[0]).then(
            (ecg) => {
                if (this.protocolList.filter((protocol) => ecg.protocol === protocol.value)[0]) {
                    this.protocol = this.protocolList.filter((protocol) => ecg.protocol === protocol.value)[0];
                    this.defaultProtocol.isSelected = false;
                } else {
                    this.protocol = this.defaultProtocol;
                }
                // this.protocol = this.protocolList.filter((protocol) => ecg.protocol === protocol.value)[0] ? this.protocolList.filter((protocol) => ecg.protocol === protocol.value)[0] : this.defaultProtocol;
                this.connectionType =
                    ecg.winRmTransport === 'HTTPS' ? this.defaultConnection : this.connectionTypeList[0];
                // this.protocol = ecg.protocol;
                this.ecg = ecg;
                this.authType = this.authenticationList.filter((authType) => ecg.authType === authType.value)[0];
                this.port = ecg.port;
                this.credGroup = ecg;
                if (this.ecg.authType === this.authType.value) {
                    this.enableChangePass = false;
                    this.enableChangePrivateKey = false;
                } else {
                    this.enableChangePass = true;
                    this.enableChangePrivateKey = true;
                }

                this.changeState(this.EDIT_STATE);
            },
            (err) => {}
        );
    }

    deleteCredentials() {
        return this.deleteCredGroup(this.selectedCredGroups[0]);
    }

    saveCredGroup() {
        this.credGroup.protocol = this.protocol.value;
        this.credGroup.authType = this.authType.value;
        this.credGroup.privateKey = this.privateKeyJson.content;

        if (!this.enableChangePass) {
            delete this.credGroup.password;
        }

        if (this.credGroup.protocol === 'AUTO') {
            this.credGroup.authType = 'PASSWORD';
            delete this.credGroup.port;
        } else if (this.credGroup.protocol === 'WIN_RM') {
            this.credGroup.authType = 'PASSWORD';
            this.credGroup.winRmTransport = this.credGroup.protocol === 'WIN_RM' ? this.connectionType.value : null;
        }

        if (this.credGroup.authType === 'PUBLIC_KEY') {
            delete this.credGroup.password;
        } else if (this.credGroup.authType === 'PASSWORD') {
            delete this.credGroup.sshKey;
        }

        this.busy = this.persistence[this.state === this.CREATE_STATE ? 'createCredGroup' : 'updateCredGroup'](
            this.credGroup
        )
            .then(
                (res) => {
                    this.reload = true;
                    this.switcherOnChange = true;
                    this.state === this.CREATE_STATE
                        ? this.reloadOnSave(true, this.credGroup)
                        : this.load(false, false, null, true);
                    this.notificationService.pop(res.data.message);
                    if (res.data.message.type === 'OK') {
                        this.changeState(this.MAIN_STATE);
                    }
                },
                (err) => {
                    this.dialogForm.$valid = true;
                    this.busy = false;
                }
            )
            .finally(() => {});
    }

    deleteCredGroup(credGroup) {
        this.dialogService
            .showYesNo(
                this.$filter('translate')('vm.credentials.deleteDialog.text', { name: credGroup.name }),
                this.$filter('translate')('vm.credentials.deleteDialog.title'),
                null,
                'delete-cg'
            )
            .then((result) => {
                if (result) {
                    this.busy = true;
                    this.reload = true;
                    return this.persistence.deleteCredGroup(credGroup);
                }
            })
            .then(
                (res) => {
                    if (res) {
                        this.notificationService.pop(res.data.message);
                        this.selectedCredGroups = [];
                        this.load(null, true);
                    }
                },
                (err) => {}
            );
    }

    assignCredGroup(credGroup) {
        let warningMessage = [],
            filteredArray,
            protectedOfflineVms = this.selectedVms.filter((vm) => vm.status === VM_PROTECTED_DELETED);
        this.err = null;
        if (protectedOfflineVms.length) {
            warningMessage.push({
                message:
                    protectedOfflineVms.length === 1
                        ? this.$filter('translate')('vm.assign.disabled.single', protectedOfflineVms[0].uuid)
                        : this.$filter('translate')(
                              'vm.assign.disabled.multi',
                              _.join(
                                  protectedOfflineVms.map((i) => i.uuid),
                                  ', '
                              )
                          ),
                notice:
                    protectedOfflineVms.length === 1
                        ? this.$filter('translate')('vm.assign.protectedOffline.notice.single')
                        : this.$filter('translate')('vm.assign.protectedOffline.notice.multi'),
            });
            this.dialogService
                .showInfo(warningMessage)
                .then(() => {
                    filteredArray = this.selectedVms.filter((i) => i.status !== VM_PROTECTED_DELETED);
                    if (filteredArray.length !== 0) {
                        this.assignCredGroupAction(credGroup, filteredArray);
                    } else {
                        this.showModal = false;
                        this.onClose();
                    }
                })
                .then(
                    () => {},
                    (err) => (this.err = err)
                );
        } else {
            this.assignCredGroupAction(credGroup, this.selectedVms);
        }
    }

    assignCredGroupAction(credGroup, selectedVms) {
        this.busy = true;
        this.persistence
            .assignCredGroup(
                credGroup,
                selectedVms.map((virtualMachine) => virtualMachine.uuid)
            )
            .then(
                (res) => {
                    this.notificationService.pop(res.data.message);
                },
                (err) => {}
            )
            .finally(() => {
                this.showModal = false;
                this.vmsCtrl.reselectVirtualMachines();
                this.onClose();
            });
    }

    onOpen() {
        this.state = this.MAIN_STATE;
        this.currentCredentials = null;
        this.isUnassignAllEnbled = null;
        this.load(true);
        this.closeId = {
            close: 'virtual-machines-credentials-close',
            closeIcon: 'virtual-machines-credentials-close-icon',
        };
    }

    load(firstPage, animate, cg, onEdit) {
        this.busy = true;
        return this.persistence.getCredGroups(firstPage).then((credGroups) => {
            let selectedItem;
            this.credGroups = credGroups;
            this.isUnassignAllEnbled = this.enableClearAllButton(this.selectedVms);
            this.currentCredentials = this.getCredentialsOfItems(this.selectedVms);
            if (this.animateSwitcher && !this.switcherOnChange) {
                this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                    this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                    this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                });
            }
            if (this.currentCredentials && this.currentCredentials.length === 1 && !onEdit) {
                this.selectedCredGroups = this.credGroups.filter((item) => item.name === this.currentCredentials[0]);
            }
            if (onEdit) {
                this.selectedCredGroups = this.credGroups.filter((item) => item.name === this.credGroup.name);
            }
            if (cg) {
                selectedItem = this.credGroups.filter((item) => item.name === cg.name)[0];
                if (selectedItem) this.selectedCredGroups = [selectedItem];
            }
            this.switcherOnChange = false;
            this.busy = false;
            return {
                page: this.persistence.credTableState ? this.persistence.credTableState.page : 1,
                selected: selectedItem,
                length: this.credGroups.length,
            };
        });
    }

    reloadOnSave(firstPage, item) {
        if (!firstPage) this.persistence.credTableState.page++;
        else this.persistence.credTableState.searchBy = undefined;

        this.switcherOnChange = true;
        this.load(firstPage, false, item).then((res) => {
            if (!res.length) return;
            if (!res.selected) {
                this.reloadOnSave(false, this.credGroup);
            }
        });
    }

    getCredentialsOfItems(selectedItems) {
        if (!selectedItems || !selectedItems.length) {
            return null;
        }
        let credentialsItems = selectedItems.filter((item) => item.credential).map((i) => i.credential);
        return this.credGroups.filter((cg) => credentialsItems.indexOf(cg.name) > -1).map((i) => i.name);
    }

    enableClearAllButton(selectedItems) {
        return selectedItems && selectedItems.filter((item) => item.credential).length > 0;
    }

    clearCredentials(clearAll) {
        /// const credentials = !clearAll ? this.selectedCredGroups[0] : null;
        const credentials = !clearAll ? null : null;

        this.unassignDialog(clearAll).then((result) => {
            if (!result) return false;
            this.busy = this.onUnAssign({ credentials }).then(() => {
                this.showModal = false;
                this.onClose();
            });
        });
    }

    unassignDialog(clearAll) {
        return this.dialogService.showYesNo(
            clearAll
                ? this.$filter('translate')('credentials.dialog.unassignAll.text', { name: 'virtual machines' })
                : this.$filter('translate')('credentials.dialog.unassign.text'),
            this.$filter('translate')('credentials.dialog.unassign.title'),
            this.$filter('translate')('credentials.dialog.unassign.notice', { name: 'virtual machines' }, 'unassign-cg')
        );
    }

    onBackAction() {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.onModalClose();
            });
        } else {
            this.onModalClose();
        }
    }

    onModalClose() {
        this.err = null;
        if (this.state !== this.MAIN_STATE) {
            this.state = this.MAIN_STATE;
            this.protocol = this.defaultProtocol;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.authType = this.authenticationList[0];
            return { preventDefault: true };
        }
        this.persistence.credTableState.searchBy = '';
        this.selectedCredGroups = [];
        this.currentCredentials = null;
        this.credGroup = null;
        this.state = this.MAIN_STATE;
        this.protocol = this.defaultProtocol;
        this.enableChangePass = false;
        this.busy = false;
        if (this.reload) {
            this.reload = false;
            this.onClose();
        }
    }

    onTitleClick() {
        this.changeState(this.MAIN_STATE);
    }

    configCredGroupTable() {
        this.credTableConfig = [
            this.$filter('translate')('vm.credentials.table.header.name'),
            this.$filter('translate')('vm.credentials.table.header.username'),
            this.$filter('translate')('vm.credentials.table.header.protocol'),
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: [],
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('33%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('33%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('34%');

        this.$timeout(() => {
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    sortTable() {
        this.load();
    }

    getMinHeight() {
        let modalBody = this.$element.find('.modal-body'),
            minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight
            ? parseFloat(minHeight) -
                  parseFloat(modalBody.css('padding-top')) -
                  parseFloat(modalBody.css('padding-bottom'))
            : null;
    }

    downloadPublicKey(credGroup) {
        this.fileName = credGroup.name + '_publicKey.txt';
        this.persistence.downloadPublicKey(credGroup.uuid).then(
            (resp) => {
                this.utilsService.saveData(resp, this.fileName, 'application/json');
            },
            (err) => {}
        );
    }

    isRequired() {
        if (this.authType === 'CREDENTIALS') {
            return true;
        }

        if (this.authType === 'SSH_KEY') {
            return true;
        }
    }

    onAuthenticationChanges() {
        if (this.ecg && this.ecg.authType === this.authType.value && this.ecg.hasPassword) {
            this.enableChangePrivateKey = false;
            this.enableChangePass = false;
        } else {
            this.enableChangePrivateKey = true;
            this.enableChangePass = true;
            this.resetPassword = true;
        }
        this.credGroup.password = null;
        this.credGroup.hasPrivateKey = false;
        this.publicKeyJson = {};
        this.publicKeyNameJson = {};
    }

    onProtocolChanges() {
        this.credGroup.port = this.protocol.value === 'AUTO' ? null : this.protocol.value !== 'WIN_RM' ? 22 : 5985;
        this.privateKeyJson = {};
        this.privateKeyNameJson = {};

        if (
            !(
                this.state === this.EDIT_STATE &&
                this.credGroup.hasPassword &&
                (!this.enableChangePass || !this.resetPassword)
            )
        ) {
            this.enableChangePass = true;
        }
    }

    isSaveDisabled() {
        return (
            (this.dialogForm && !this.dialogForm.$valid) ||
            this.busy ||
            this.state === this.MAIN_STATE ||
            ((!this.privateKeyJson || !this.privateKeyNameJson || !this.privateKeyNameJson.content) &&
                this.enableChangePrivateKey &&
                this.state === this.EDIT_STATE &&
                this.protocol.value === 'SSH' &&
                this.authType.value === 'PRIVATE_KEY') ||
            ((!this.privateKeyJson || !this.privateKeyNameJson || !this.privateKeyNameJson.content) &&
                this.state === this.CREATE_STATE &&
                this.protocol.value === 'SSH' &&
                this.authType.value === 'PRIVATE_KEY')
        );
    }

    isCreateDisabled() {
        return !this.iamPersistenceService.hasPermissions(permissions.VM_CREDENTIALS_CREATE);
    }

    isEditDisabled() {
        return (
            !this.iamPersistenceService.hasPermissions(permissions.VM_CREDENTIALS_UPDATE) ||
            !this.selectedCredGroups ||
            !this.selectedCredGroups.length ||
            this.selectedCredGroups.length === 0
        );
    }

    isDeleteDisabled() {
        return (
            !this.iamPersistenceService.hasPermissions(permissions.VM_CREDENTIALS_DELETE) ||
            !this.selectedCredGroups ||
            !this.selectedCredGroups.length ||
            this.selectedCredGroups.length === 0
        );
    }

    isDownloadPKDisabled() {
        return (
            !this.iamPersistenceService.hasPermissions(permissions.VM_DOWNLOAD_PUBLIC_KEY) ||
            !this.selectedCredGroups ||
            !this.selectedCredGroups.length ||
            !this.selectedCredGroups[0].download
        );
    }
}

CredentialsDialogController.$inject = [
    '$scope',
    '$animate',
    '$element',
    '$filter',
    '$timeout',
    '$document',
    'crudService',
    'utilsService',
    'virtualMachinesPersistence',
    'dialogService',
    'notificationService',
    'contentSwitcherService',
    'validationsService',
    'iamPersistenceService',
];

const credentialsDialogComponent = {
    controller: CredentialsDialogController,
    require: {
        vmsCtrl: '^^virtualMachines',
    },
    template: require('./credentialsDialog.template.html'),
    bindings: {
        showModal: '=',
        selectedVms: '<',
        onClose: '&',
        onUnAssign: '&',
    },
};

module.exports = credentialsDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/credentialsDialog/credentialsDialog.component.js